module.exports = __webpack_public_path__ + "static/media/0012_Medium.8fa7cf27.jpg";